'use client'

import { useEffect, useState } from 'react'
import { FaLock, FaTimes } from 'react-icons/fa'
import Portal from './Portal'

import { useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
import { poseListModel } from '../helpers/helpers'

const emotions = [
  {
    title: 'Default',
    src: '/assets/emotions/default.webp',
    animeSrc: '/assets/emotions/default.webp',
    plan: 'Free',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Smiling',
    animeSrc: '/assets/emotions/smiling_anime.webp',
    src: '/assets/emotions/real-smile.webp',
    plan: 'Free',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Orgasm Face',
    animeSrc: '/assets/emotions/anime-orgasm-face.webp',
    src: '/assets/emotions/real-orgasm-face.webp',
    plan: 'Plus',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Stick out Tongue',
    animeSrc: '/assets/emotions/anime-stick-out-tongue.webp',
    src: '/assets/emotions/stick-out-tongue.webp',
    plan: 'Plus',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Angry',
    animeSrc: '/assets/emotions/anime-angry.webp',
    src: '/assets/emotions/real-angry.webp',
    plan: 'Plus',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Upset',
    animeSrc: '/assets/emotions/anime-upset.webp',
    src: '/assets/emotions/real-upset.webp',
    plan: 'Plus',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Disgusted',
    animeSrc: '/assets/emotions/anime-disgusted.webp',
    src: '/assets/emotions/real-disgusted.webp',
    plan: 'Premium',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Scared',
    animeSrc: '/assets/emotions/anime-scared.webp',
    src: '/assets/emotions/real-scared.webp',
    plan: 'Premium',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },

  {
    title: 'Ouch',
    animeSrc: '/assets/emotions/anime-pain.webp',
    src: '/assets/emotions/real-pain.webp',
    plan: 'Pro',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Shocked',
    animeSrc: '/assets/emotions/anime-shocked.webp',
    src: '/assets/emotions/real-shocked.webp',
    plan: 'Pro',
    enabled: [
      'Cinematic Flame',
      'Anime Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
  {
    title: 'Winking',
    animeSrc: '/assets/emotions/anime-winking.webp',
    src: '/assets/emotions/real-winking.webp',
    plan: 'Pro',
    enabled: [
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
      ,
    ],
  },
]

const EmotionModal = ({
  isOpen,
  closeModal,
  subscription,
  model,
  emotion,
  setEmotion,
  safe,
}) => {
  const { t } = useTranslation()

  const router = useRouter()

  const { isPlusOrHigher, isPremiumOrHigher, isStudioOrHigher } = useAuth()

  const [selectedImage, setSelectedImage] = useState(null)
  const [shouldRender, setShouldRender] = useState(isOpen)

  useEffect(() => {
    if (isOpen) setShouldRender(true)
  }, [isOpen])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset'
  }, [isOpen])

  const handleImageClick = (e, image) => {
    e.preventDefault()
    if (!canSelectImage(image.plan)) {
      router.push('/upgrade')
    } else if (canSelectImage(image.plan)) {
      setSelectedImage(image)
      setEmotion(image.title)
      closeModal()
    }
  }

  const getColorForPlan = (plan = 'Free') => {
    switch (plan) {
      case 'Pro':
      case 'Studio':
        return '#FFB419'
      case 'Premium':
        return '#7ED6FF'
      case 'Plus':
        return '#E54B00'
      default:
        return '#FFFFFF'
    }
  }

  const canSelectImage = (imagePlan) => {
    switch (imagePlan) {
      case 'Free':
        return true
      case 'Plus':
        return isPlusOrHigher
      case 'Premium':
        return isPremiumOrHigher
      case 'Pro':
      case 'Studio':
        return isStudioOrHigher
      default:
        return false
    }
  }

  if (!shouldRender) {
    return null
  }

  return (
    <Portal>
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeModal()
          }
        }}
        className={`fixed z-[110] top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center ${
          isOpen ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-200 ${
          isOpen ? 'pointer-events-auto' : 'pointer-events-none'
        }`}
      >
        <div
          className={`bg-[var(--middle-bg-color)] h-3/4 md:h-2/3 w-3/4 md:w-2/3 flex flex-col rounded-lg shadow-2xl p-6 text-gray-100 space-y-4 relative transform transition-all duration-200 ${
            isOpen ? 'scale-100 opacity-100' : 'scale-70 opacity-0'
          }`}
        >
          <header>
            <h2 className="text-xl font-semibold text-shadow"> {t(emotion)}</h2>

            <button
              onClick={closeModal}
              className="absolute right-2 top-2 m-4 text-white"
              style={{ fontSize: '1.5rem' }}
            >
              <FaTimes />
            </button>
          </header>
          <hr className="border-gray-800" />

          <main className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1 overflow-y-auto overflow-x-hidden flex-grow p-2">
            {emotions
              .filter(
                (image) =>
                  !image.enabled ||
                  image.enabled.includes(poseListModel(model)),
              )
              .map((image) => (
                <div
                  key={image.title}
                  className={`m-1 border-2 relative rounded-xl transition-all duration-200 ease-in-out 
        ${
          image === selectedImage
            ? 'border-white shadow-outline-blue'
            : canSelectImage(image.plan)
              ? 'border-transparent hover:shadow-lg hover:border-gray-800 hover:scale-[1.03] cursor-pointer'
              : 'border-transparent'
        }`}
                  onClick={(e) => handleImageClick(e, image)}
                >
                  <img
                    src={
                      safe
                        ? '/assets/models/random.webp'
                        : model === 'Anime' ||
                            model === 'Anime XL' ||
                            model === 'Pony Anime XL' ||
                            model === 'Hyperanime' ||
                            model === 'Fur' ||
                            model === 'Furtoon' ||
                            model === 'Anime Flame'
                          ? image.animeSrc
                          : image.src
                    }
                    alt={image.title}
                    className={`w-full h-full object-cover rounded-xl ${
                      canSelectImage(image.plan) ? '' : 'opacity-80'
                    }`}
                  />
                  {!canSelectImage(image.plan) ? (
                    <div
                      className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 rounded-xl border-2"
                      style={{ borderColor: getColorForPlan(image.plan) }}
                    >
                      <span className="text-gray-300 flex items-center opacity-60 font-semibold">
                        <FaLock className="mr-1" /> {image.plan}
                      </span>

                      <p className="font-semibold absolute bottom-0 mb-2 ml-2 text-gray-300 text-sm bg-black bg-opacity-50 rounded px-1">
                        {t(image.title)}
                      </p>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <p className="font-semibold absolute bottom-0 mb-2 ml-2 text-white text-sm bg-black bg-opacity-50 rounded px-1">
                        {t(image.title)}
                      </p>
                    </div>
                  )}
                </div>
              ))}
          </main>
        </div>
      </div>
    </Portal>
  )
}

export default EmotionModal
